export const RUNTIME_BASE_URL = (() => {
  let value
  try {
    value = process.env.RUNTIME_BASE_URL
  } catch (e) {}
  return value || 'https://cloudflareworkers.com'
})()

export const DEVTOOLS_URL = (() => {
  let value
  try {
    value = process.env.DEVTOOLS_URL
  } catch (e) {}
  return (
    value ||
    localStorage.getItem('DEVTOOLS_URL') ||
    'https://devtools.devprod.cloudflare.dev/js_app?theme=default'
  )
})()



// WEBPACK FOOTER //
// ./src/lib/config.ts